"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorsToJSON = exports.ErrorsFromJSONTyped = exports.ErrorsFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ErrorsFromJSON(json) {
    return ErrorsFromJSONTyped(json, false);
}
exports.ErrorsFromJSON = ErrorsFromJSON;
function ErrorsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enrollment': !runtime_1.exists(json, 'enrollment') ? undefined : _1.EnrollmentFromJSON(json['enrollment']),
        'businessErrors': !runtime_1.exists(json, 'businessErrors') ? undefined : (json['businessErrors'].map(_1.BusinessServiceErrorFromJSON)),
        'errors': !runtime_1.exists(json, 'errors') ? undefined : (json['errors'].map(_1.ServiceErrorFromJSON)),
    };
}
exports.ErrorsFromJSONTyped = ErrorsFromJSONTyped;
function ErrorsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enrollment': _1.EnrollmentToJSON(value.enrollment),
        'businessErrors': value.businessErrors === undefined ? undefined : (value.businessErrors.map(_1.BusinessServiceErrorToJSON)),
        'errors': value.errors === undefined ? undefined : (value.errors.map(_1.ServiceErrorToJSON)),
    };
}
exports.ErrorsToJSON = ErrorsToJSON;
//# sourceMappingURL=Errors.js.map